import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  FaWater, 
  FaUser, 
  FaLock, 
  FaEye, 
  FaEyeSlash,
  FaArrowRight,
  FaExclamationTriangle,
  FaCheck,
  FaTint
} from 'react-icons/fa';
import { MdVerified } from 'react-icons/md';
import '../../styles/Login.css';
import iconCompraFacil from '/logo.jpeg';

export default function LoginScreen() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [cpf, setCpf] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [lembrar, setLembrar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isCompraFacil = window.location.hostname === 'abastecimento.comprafacil.pi.gov.br';

  function formatarCpf(texto) {
    const numeros = texto.replace(/\D/g, '');
    if (numeros.length <= 9) {
      return numeros.replace(/(\d{3})(\d{3})(\d{3})/, '$1.$2.$3');
    }
    return numeros.slice(0, 11).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  const handleEntrar = async () => {
    if (!cpf || !senha) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    const cpfLimpo = cpf.replace(/\D/g, '');
    if (cpfLimpo.length !== 11) {
      setError('CPF inválido.');
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const response = await login(cpfLimpo, senha);

      if (response.success) {
        if (lembrar) {
          localStorage.setItem('rememberCpf', cpfLimpo);
        } else {
          localStorage.removeItem('rememberCpf');
        }
        
        navigate('/');
      } else {
        setError(response.message || 'Falha ao autenticar. Verifique suas credenciais.');
      }
    } catch (error) {
      console.error('Erro no login:', error);
      setError('Ocorreu um erro ao tentar fazer login. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleEntrar();
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        {/* Header */}
        <div className="login-header">
            {isCompraFacil ? (
              <div className="icon-box-compra-facil" style={{ 
                width: '300px',
                height: '200px',
                borderRadius: '20px',      
                overflow: 'hidden', 
              }}>
                <img src={iconCompraFacil} alt="CompraFácil" style={{ width: '150%', height: '150%', objectFit: 'contain' }} />
              </div>
            ) : (
              <div className="icon-box">
                <FaTint className="water-icon" />
              </div>
            )}
          {isCompraFacil ? "" : <h1 className="app-name">GuardVisio</h1>}
        </div>

        {/* Card de login */}
        <div className="login-card">
          <h2 className="welcome-title">Bem-vindo</h2>
          <p className="welcome-subtitle">Acesse sua conta para continuar</p>

          {error && (
            <div className="error-message">
              <FaExclamationTriangle className="error-icon" />
              <span>{error}</span>
            </div>
          )}

          <div className="form-group">
            <label className="form-label">CPF</label>
            <div className="input-wrapper">
              <FaUser className="input-icon" />
              <input
                type="text"
                className="form-input"
                placeholder="000.000.000-00"
                value={cpf}
                onChange={(e) => setCpf(formatarCpf(e.target.value))}
                maxLength={14}
                disabled={loading}
                autoComplete="off"        
                autoCorrect="off"         
                autoCapitalize="off"  
                spellCheck="false"  
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Senha</label>
            <div className="input-wrapper">
              <FaLock className="input-icon" />
              <input
                type={mostrarSenha ? 'text' : 'password'}
                className="form-input"
                placeholder="••••••••"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
              />
              <button 
                type="button"
                className="toggle-password"
                onClick={() => setMostrarSenha(!mostrarSenha)}
                tabIndex={-1}
              >
                {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

           {/*<div className="options-row">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={lembrar}
                onChange={(e) => setLembrar(e.target.checked)}
                disabled={loading}
              />
              <span className="checkbox-text">Lembrar de mim</span>
            </label>
           <button className="forgot-link" onClick={}>
              Esqueci minha senha
            </button>
          </div>*/}

          <button 
            className={`login-button ${loading ? 'loading' : ''}`}
            onClick={handleEntrar}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="spinner-small"></div>
                <span>Entrando...</span>
              </>
            ) : (
              <>
                <FaArrowRight className="button-icon" />
                <span>Entrar</span>
              </>
            )}
          </button>

          <p className="terms-text">
            Ao acessar, você concorda com os{' '}
            <button className="terms-link" onClick={() => alert('Termos de Uso')}>
              Termos de Uso
            </button>
            {' '}e{' '}
            <button className="terms-link" onClick={() => alert('Política de Privacidade')}>
              Política de Privacidade
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}